<div class="Header" *ngIf="header">
    <span class="title"> Negotiation List</span>
    <span class="desc"> Bellow are the list of previous quote.</span>
</div>

<ng-container *ngIf="this.requestType.dev_name=='one_way'">
    <div class="setTable">
        <mat-table [dataSource]="quoteHistoryList">
            <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

            <!-- Quote No Column -->
            <ng-container matColumnDef="quote_no">
                <mat-header-cell *matHeaderCellDef> Quote No </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element?.quote_number}} </mat-cell>
            </ng-container>

            <!-- Quoted on Column -->
            <ng-container matColumnDef="created_at">
                <mat-header-cell *matHeaderCellDef> Quoted on </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element?.created_at | date:"dd MMM, yyyy"}}
                    by {{element?.created_by?.first_name}} </mat-cell>
            </ng-container>

            <!-- Quoted Valid Till -->
            <ng-container matColumnDef="quote_valid_till">
                <mat-header-cell *matHeaderCellDef> Validity </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element?.quote_valid_till | date:"dd MMM, yyyy"}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="created_by">
                <mat-header-cell *matHeaderCellDef> Quoted by </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element?.created_by.first_name}} {{element?.created_by.last_name}} </mat-cell>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <a (click)="downloadQuote(element)">
                        <i class="flaticon-download"></i></a>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedOneWayColumns" class="header-row"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedOneWayColumns;"></mat-row>
        </mat-table>
    </div>
</ng-container>


<ng-container *ngIf="this.requestType.dev_name=='buy_sell'">
    <div class="setTable">
        <mat-table [dataSource]="quoteHistoryList">
            <!-- Quote No Column -->
            <ng-container matColumnDef="quote_no">
                <mat-header-cell *matHeaderCellDef> Quote No </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element?.quote_number}} </mat-cell>
            </ng-container>

            <!-- Quoted on Column -->
            <ng-container matColumnDef="created_at">
                <mat-header-cell *matHeaderCellDef> Quoted on </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element?.created_at | date:"dd MMM, yyyy"}}
                    by {{element?.created_by?.first_name}} </mat-cell>
            </ng-container>

            <!-- Quoted Valid Till -->
            <ng-container matColumnDef="quote_valid_till">
                <mat-header-cell *matHeaderCellDef> Validity </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element?.quote_valid_till | date:"dd MMM, yyyy"}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="created_by">
                <mat-header-cell *matHeaderCellDef> Quoted by </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element?.created_by.first_name}} {{element?.created_by.last_name}} </mat-cell>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <a (click)="downloadQuote(element)">
                        <i class="flaticon-download"></i></a>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedTradeColumns" class="header-row"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedTradeColumns;"></mat-row>
        </mat-table>
    </div>
</ng-container>

<ng-container *ngIf="this.requestType.dev_name=='lease'">
    <div class="setTable">
        <mat-table [dataSource]="quoteHistoryList">
            <!-- Quote No Column -->
            <ng-container matColumnDef="quote_no">
                <mat-header-cell *matHeaderCellDef> Quote No </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element?.quote_number}} </mat-cell>
            </ng-container>

            <!-- Quoted on Column -->
            <ng-container matColumnDef="created_at">
                <mat-header-cell *matHeaderCellDef> Quoted on </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element?.created_at | date:"dd MMM, yyyy"}}
                    by {{element?.created_by?.first_name}} </mat-cell>
            </ng-container>

            <!-- Quoted Valid Till -->
            <ng-container matColumnDef="quote_valid_till">
                <mat-header-cell *matHeaderCellDef> Validity </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element?.quote_valid_till | date:"dd MMM, yyyy"}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="created_by">
                <mat-header-cell *matHeaderCellDef> Quoted by </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element?.created_by.first_name}} {{element?.created_by.last_name}} </mat-cell>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                <mat-cell *matCellDef="let element">
                        <a (click)="downloadQuote(element)">
                        <i class="flaticon-download"></i></a>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedTradeColumns" class="header-row"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedTradeColumns;"></mat-row>
        </mat-table>
    </div>
</ng-container>